<template>
    <footer class="main-footer">
        <div class="list-info">
            <div class="container">
                <div class="row">
        
                </div>
            </div>
        </div>
        <div class="container-fluid footer-pleca">
            <div class="row">
                <div class="col"><br><br></div>
            </div>
        </div>
    </footer>
</template>
  
  <script setup>
  </script>
  
  <style scoped>
  .label,
sub,
sup {
    vertical-align: baseline
}

.btn,
.btn-group,
.btn-group-vertical,
.caret,
.checkbox-inline,
.radio-inline,
img {
    vertical-align: middle
}

hr,
img {
    border: 0
}

body,
figure {
    margin: 0
}

.img-responsive,
.img-thumbnail,
.table,
label {
    max-width: 100%
}

footer {
    display: block
}

a {
    background-color: transparent;
    color: #12C
}

a:active,
a:hover {
    outline: 0
}

hr {
    box-sizing: content-box;
    height: 0
}

.glyphicon {
    font-style: normal
}

button::-moz-focus-inner,
input::-moz-focus-inner {
    border: 0;
    padding: 0
}

/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */

@media print {
    blockquote,
    img,
    pre,
    tr {
        page-break-inside: avoid
    }
    *,
    :after,
    :before {
        background: 0 0!important;
        color: #000!important;
        box-shadow: none!important;
        text-shadow: none!important
    }
    a,
    a:visited {
        text-decoration: underline
    }
    a[href]:after {
        content: " (" attr(href) ")"
    }
    abbr[title]:after {
        content: " (" attr(title) ")"
    }
    a[href^="#"]:after,
    a[href^="javascript:"]:after {
        content: ""
    }
    blockquote,
    pre {
        border: 1px solid #999
    }
    thead {
        display: table-header-group
    }
    img {
        max-width: 100%!important
    }
    h2,
    h3,
    p {
        orphans: 3;
        widows: 3
    }
    h2,
    h3 {
        page-break-after: avoid
    }
    .navbar {
        display: none
    }
    .btn>.caret,
    .dropup>.btn>.caret {
        border-top-color: #000!important
    }
    .label {
        border: 1px solid #000
    }
    .table {
        border-collapse: collapse!important
    }
    .table td,
    .table th {
        background-color: #fff!important
    }
    .table-bordered td,
    .table-bordered th {
        border: 1px solid #ddd!important
    }
}


*,
:after,
:before {
    box-sizing: border-box
}

a:focus,
a:hover {
    color: #7B9CF0;
    text-decoration: underline
}

a:focus {
    outline-offset: -2px
}

hr {
    margin-top: 25px;
    margin-bottom: 25px;
    border-top: 1px solid #eee
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit
}

.h1,
.h2,
.h3,
h1,
h2,
h3 {
    margin-top: 25px;
    margin-bottom: 12.5px
}

h1 .small,
h1 small,
h2 .small,
h2 small,
h3 .small,
h3 small {
    font-size: 65%
}

.h4,
.h5,
.h6,
h4,
h5,
h6 {
    margin-top: 12.5px;
    margin-bottom: 12.5px
}

h4 .small,
h4 small,
h5 .small,
h5 small,
h6 .small,
h6 small {
    font-size: 75%
}

.h1,
h1 {
    font-size: 54px
}

.h2,
h2 {
    font-size: 38px
}

.h3,
h3 {
    font-size: 28px
}

.h4,
h4 {
    font-size: 24px
}

.h5,
h5 {
    font-size: 18px
}

.h6,
h6 {
    font-size: 16px
}

p {
    margin: 0 0 12.5px
}

dl,
ol,
ul {
    margin-top: 0
}

blockquote ol:last-child,
blockquote p:last-child,
blockquote ul:last-child,
ol ol,
ol ul,
ul ol,
ul ul {
    margin-bottom: 0
}

ol,
ul {
    margin-bottom: 12.5px
}

.list-inline {
    margin-left: -5px
}

.list-inline>li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px
}

dd {
    margin-left: 0
}

@media (min-width:768px) {
    .container {
        width: 750px
    }
}

.container-fluid:after,
.container:after,
.row:after {
    clear: both
}

.container-fluid:after,
.container-fluid:before,
.container:after,
.container:before,
.row:after,
.row:before {
    display: table;
    content: " "
}

.container,
.container-fluid {
    margin-right: auto;
    margin-left: auto
}

.container,
.container-fluid {
    padding-left: 15px;
    padding-right: 15px
}

@media (min-width:992px) {
    .container {
        width: 970px
    }
}

@media (min-width:1200px) {
    .container {
        width: 1170px
    }
}

.row {
    margin-left: -15px;
    margin-right: -15px
}

.col-sm-3 {
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px
}

@media (min-width:768px) {
    .col-sm-3 {
        float: left
    }

    .col-sm-3 {
        width: 25%
    }
}

.container-fluid>.navbar-collapse,
.container-fluid>.navbar-header,
.container>.navbar-collapse,
.container>.navbar-header {
    margin-right: -15px;
    margin-left: -15px
}

@media (min-width:768px) {
    .container-fluid>.navbar-collapse,
    .container-fluid>.navbar-header,
    .container>.navbar-collapse,
    .container>.navbar-header {
        margin-right: 0;
        margin-left: 0
    }
    .navbar>.container .navbar-brand,
    .navbar>.container-fluid .navbar-brand {
        margin-left: -15px
    }
}

a {
    text-decoration: underline
}

.main-footer .list-info a.link-email,
.main-footer .list-info a:hover {
    text-decoration: none
}

a.active,
a:active {
    color: #10C7E0
}

a:focus {
    outline: #bbb dotted 1px
}

.social-icon {
    background-image: url(https://framework-gb.cdn.gob.mx/assets/images/icons_full.png);
    display: block;
    text-indent: -9999px;
    margin-right: 5px
}

.social-icon.facebook {
    width: 14px;
    height: 20px;
    background-position: 0 0
}

.social-icon.twitter {
    width: 24px;
    height: 20px;
    background-position: -34px 0
}

.main-footer {
    background-color: #011C26;
    min-height: 200px;
    color: #FFF;
    padding: 0px 0 0px;
    text-align: left;
    font-weight: 300;
    font-family: 'Montserrat', Arial, Helvetica, Verdana, Tahoma, Geneva, sans-serif;
    background-position: bottom;
}

.main-footer .list-info {
    line-height: auto;
    /*background-color: #12322B;*/

    /* background-image: url(https://framework-gb.cdn.gob.mx/landing/img/fondofooter3.svg); */
    color: white;
    background-size: cover;
    background-position: bottom;
    padding: 30px 10px 10px;
    font-family: 'Montserrat', Arial, Helvetica, Verdana, Tahoma, Geneva, sans-serif;
    /*margin-bottom: 30px*/
}

.main-footer .list-info form label {
    font-weight: 300;
    margin-bottom: 15px;
    line-height: 110%;
    color: black;
}

.main-footer .list-info form .form-group-icon {
    max-width: none;
    font-size: 14px
}

.main-footer .list-info form .form-control {
    font-size: 14px
}

.main-footer .list-info h5 {
    font-weight: 300;
    margin-bottom: 20px
}

.main-footer .list-info a {
    color: #FFF;
    font-size: 14px;
    text-decoration: none;
}

.main-footer .list-info a.link-email {
    color: #fff;
    font-size: 14px
}

.main-footer .list-info p {
    margin-bottom: 15px
}

.main-footer .list-info ul {
    margin: 0 0 60px;
    padding: 0
}

.main-footer .list-info ul li {
    list-style-type: none;
    margin: 0 0 2px;
    padding: 0;
    line-height: 110%
}

.main-footer .row>div {
    margin-bottom: 15px
}

.main-footer p {
    margin: 0;
    font-size: 14px;
    line-height: 136%;
    height: auto;
    position: static
}

.gobmx-footer {
    margin-top: 15px
}

.message-subscribe {
    margin-top: 20px;
    font-size: 14px
}

@media (min-width:768px) {
    .main-footer {
        text-align: left
    }
    .main-footer .list-info form .form-group-icon {
        max-width: 300px
    }
    .main-footer .row>div {
        margin-bottom: 0
    }
}

.footer-pleca {
    background-color: #12322B;
    background-image: url(https://framework-gb.cdn.gob.mx/landing/img/pleca.svg);
    background-repeat: repeat-x;
}
.list-info{
    background:#6593A6 ;
}

.container-fluid{
    background: #011C26;
}
  </style>
  